import React, { useState } from "react";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from ".././Helmet";
import MainCalculatorsList from "./MainCalculators";
const TITLE = "حاسبة قوة الاحتكاك - احسب قوة الاحتكاك اونلاين";
const DESCRIPTION =
  "حاسبة قوة الاحتكاك تقوم بحساب قوة الاحتكاك بناءً على التسارع والكتلة.";
const KEYWORDS = "قوة الاحتكاك, حساب قوة الاحتكاك, حاسبة الاحتكاك";
const OG_URL = "https://do-calculate.com/calculator/ar/frictionforce";
function FrictionForceCalculator() {
  const [acceleration, setAcceleration] = useState("");
  const [mass, setMass] = useState("");
  const [frictionalForce, setFrictionalForce] = useState("");
  const [error, setError] = useState("");
  const handleCalculate = () => {
    if (!acceleration || !mass) {
      setError("الرجاء إدخال التسارع والكتلة بشكل صحيح");
      setFrictionalForce("");
      return;
    }
    const accelerationValue = parseFloat(acceleration);
    const massValue = parseFloat(mass);
    if (isNaN(accelerationValue) || isNaN(massValue) || massValue <= 0) {
      setError("الرجاء إدخال قيم صحيحة وإيجابية للتسارع والكتلة");
      setFrictionalForce("");
      return;
    }
    const frictionalForceValue = accelerationValue * massValue;
    setFrictionalForce(frictionalForceValue.toFixed(2));
    setError("");
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div>
            <div className="row">
              <div>
                <p>لحساب قوة الاحتكاك، نحتاج إلى معرفة التسارع والكتلة.</p>
                <p>يمكن حساب قوة الاحتكاك باستخدام القاعدة التالية:</p>
                <p>
                  <b>قوة الاحتكاك (F) = التسارع (a) × الكتلة (m)</b>
                </p>
                <p>
                  حيث:
                  <br />
                  F: قوة الاحتكاك (بوحدة النيوتن - Newton).
                  <br />
                  a: التسارع (بوحدة المتر/ثانية مربعة - m/s²).
                  <br />
                  m: الكتلة (بوحدة الكيلوغرام - kg).
                </p>
                <p>
                  استخدم الحاسبة التالية لحساب قوة الاحتكاك بناءً على التسارع
                  والكتلة.
                </p>
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          التسارع (m/s²)
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="9.8"
                        value={acceleration}
                        onChange={(e) => setAcceleration(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">الكتلة (kg)</label>
                      </b>
                      <input
                        type="number"
                        placeholder="10"
                        value={mass}
                        onChange={(e) => setMass(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      احسب قوة الاحتكاك
                    </button>
                  </div>
                  <br />
                  <div>
                    {error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        خطأ: {error}
                      </p>
                    ) : (
                      <>
                        {frictionalForce !== "" && (
                          <>
                            <p className="p-3 mb-2 bg-success text-white">
                              قوة الاحتكاك (نيوتن): {frictionalForce} نيوتن
                            </p>
                            <p className="p-3 mb-2 bg-info text-black">
                              قوة الدفع = قوة المحصلة - قوة الاحتكاك الحركي
                            </p>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
         </div>
</div>
  );
}
export default FrictionForceCalculator;
